import React, { useState } from "react";

const PaginatedTable = ({ columns, data, pageSize = 10, renderRow, showPagination = true, }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(pageSize);

  // Pagination logic
  const totalPages = showPagination ? Math.ceil(data.length / rowsPerPage) || 1 : 1;
  const startIndex = showPagination ? (currentPage - 1) * rowsPerPage : 0;
  const paginatedData = showPagination
    ? data.slice(startIndex, startIndex + rowsPerPage)
    : data;

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePageSizeChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1); 
  };

  return (
    <div className="w-full rounded-xl">
      <table className="w-full border border-[#dde1e3] rounded-xl">
        <thead className="bg-white text-[#121516] text-sm font-medium text-left">
          <tr>
            {columns.map((col, index) => (
              <th key={index} className="px-4 py-2">
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {paginatedData.length > 0 ? (
            paginatedData.map((row, idx) => renderRow(row, idx))
          ) : (
            <tr>
              <td
                colSpan={columns.length}
                className="text-center py-4 text-gray-500"
              >
                No data found!
              </td>
            </tr>
          )}
        </tbody>
      </table>

{/* Pagination Controls */}
{showPagination && (
  <div className="flex justify-end items-center mt-4 mb-4 px-5 gap-6">

    {/* Rows per page */}
    <div className="flex items-center gap-2 text-sm">
      <span>Rows per page:</span>
      <select
        value={rowsPerPage}
        onChange={handlePageSizeChange}
        className="border rounded px-2 py-1 text-sm"
      >
        {[5, 10, 20, 50, 100].map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
    </div>

        {/* Prev / Next in right */}
        <div className="flex items-center gap-2">
      <button
        onClick={handlePrev}
        disabled={currentPage === 1}
        className="px-3 py-1 border rounded disabled:opacity-50"
      >
        Prev
      </button>
      <span className="text-sm">
        Page {currentPage} of {totalPages}
      </span>
      <button
        onClick={handleNext}
        disabled={currentPage === totalPages}
        className="px-3 py-1 border rounded disabled:opacity-50"
      >
        Next
      </button>
    </div>

  </div>
)}

    </div>
  );
};

export default PaginatedTable;
